import { Button } from '@/components/ui/button';
import { Loader2, RefreshCcw } from 'lucide-react';

interface RefreshButtonProps {
  onClick: () => void;
  isRefreshing: boolean;
}

export function RefreshButton({ onClick, isRefreshing }: RefreshButtonProps) {
  return (
    <Button onClick={onClick} disabled={isRefreshing} variant="outline" className="h-10">
      {isRefreshing ? (
        <span className="flex items-center justify-center gap-2">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span className="hidden md:inline">Refreshing...</span>
        </span>
      ) : (
        <span className="flex items-center justify-center gap-2">
          <RefreshCcw className="h-4 w-4" />
          <span className="hidden md:inline font-medium">Refresh</span>
        </span>
      )}
    </Button>
  );
}
